import * as React from 'react';

export const recommendedIcon = (
	<svg
		className="recommended"
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle className="recommended__circle" cx="14" cy="14" r="14" fill="currentColor" />
		<path
			className="recommended__like"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.6002 11.5108C20.2847 11.5108 20.8447 12.0708 20.8447 12.7553L20.8384 12.8051L20.8447 12.8113V13.9997C20.8447 14.1615 20.8135 14.3108 20.7575 14.4539L18.8784 18.8406C18.6918 19.2886 18.25 19.5997 17.7335 19.5997H12.1335C11.4491 19.5997 10.8891 19.0397 10.8891 18.3553V12.1331C10.8891 11.7908 11.026 11.4797 11.2562 11.2557L15.3504 7.15527L16.01 7.80861C16.178 7.97661 16.2838 8.21305 16.2838 8.46816L16.2651 8.66727L15.674 11.5108H19.6002ZM9.64465 19.5997H7.15576V12.1331H9.64465V19.5997Z"
			fill="currentColor"
		/>
	</svg>
);

export const selectedIcon = (
	<svg className="selected" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle className="selected__circle" cx="14" cy="14" r="14" fill="currentColor" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M13.6662 17.5322L21.3724 9.82602L20.0525 8.50609L12.3463 16.2123L8.57554 12.4416L7.2556 13.7615L11.0263 17.5322L11.0262 17.5323L12.3462 18.8523L12.3463 18.8522L12.3466 18.8525L13.6665 17.5326L13.6662 17.5322Z"
			className="selected__check"
			fill="currentColor"
		/>
	</svg>
);
